import { createApp } from 'vue'
import { createGtm } from '@gtm-support/vue-gtm';
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router";
import { loadFonts } from './plugins/webfontloader'

import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';
Amplify.configure(aws_exports);
const gtm = createGtm({ id: 'GTM-PN3VH3N' });

loadFonts()

createApp(App)
  .use(router)
  .use(gtm)
  .use(vuetify)
  .mount('#app');
